import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {AuthCheck} from '../../helpers'
import {GetSettingsClient, UpdateSettingsClient} from '../../api'

const SERVICE_URL = window.ENVVARS.REACT_APP_SERVICE_URL

const getSettingsClient = new GetSettingsClient(SERVICE_URL)
const updateSettingsClient = new UpdateSettingsClient(SERVICE_URL)

const initialState = {
  loading: false,
  saveLoading: false,
  error: null,
  settings: null,
}

export const digitalPlanetGetSettings = createAsyncThunk(
  'digitalplanetsettings/getSettings',
  async (_, {dispatch}) => {
    try {
      dispatch(setLoading(true))
      const response = await getSettingsClient.getSettings()
      dispatch(setSettings(response))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error?.message || 'Ayarlar alınırken hata oluştu'))
      throw error
    }
  }
)

export const digitalPlanetUpdateSettings = createAsyncThunk(
  'digitalplanetsettings/updateSettings',
  async (body, {dispatch}) => {
    try {
      dispatch(setSaveLoading(true))
      const response = await updateSettingsClient.updateSettings(body)
      dispatch(setSaveLoading(false))
      return response
    } catch (error) {
      AuthCheck(error)
      dispatch(setError(error?.message || 'Ayarlar kaydedilirken hata oluştu'))
      throw error
    }
  }
)

const digitalplanetsettingsSlice = createSlice({
  name: 'digitalplanetsettings',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSaveLoading: (state, action) => {
      state.saveLoading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
      state.saveLoading = false
    },
    setSettings: (state, action) => {
      state.settings = action.payload
      state.loading = false
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const {setLoading, setSaveLoading, setError, setSettings, clearError} =
  digitalplanetsettingsSlice.actions

export const selectDigitalPlanetSettings = (state) => state.digitalplanetsettings.settings
export const selectDigitalPlanetSettingsLoading = (state) => state.digitalplanetsettings.loading
export const selectDigitalPlanetSettingsSaveLoading = (state) =>
  state.digitalplanetsettings.saveLoading
export const selectDigitalPlanetSettingsError = (state) => state.digitalplanetsettings.error

export default digitalplanetsettingsSlice.reducer
